/**
 * Constantes BDNB (Base de Données Nationale des Bâtiments).
 * Tuiles vectorielles servies via le proxy backend → API Carex Data.
 * Même architecture que BonUrba.
 */

const API_BASE = import.meta.env.VITE_API_URL || window.location.origin

// --- Bâtiments (zoom 14) ---

export const BDNB_TILES_URL = `${API_BASE}/api/v1/data/tuiles/batiment_groupe/{z}/{x}/{y}.pbf`

export const BDNB_SOURCE_ID = 'bdnb'
export const BDNB_SOURCE_LAYER = 'batiment_groupe'
export const BDNB_FILL_LAYER_ID = 'bdnb-fill'
export const BDNB_LINE_LAYER_ID = 'bdnb-line'

/** Zoom minimal pour afficher les tuiles BDNB. */
export const BDNB_MIN_ZOOM = 14

// --- IRIS (zoom 9-13) ---

export const IRIS_TILES_URL = `${API_BASE}/api/v1/data/tuiles/iris/{z}/{x}/{y}.pbf`

export const IRIS_SOURCE_ID = 'iris'
export const IRIS_SOURCE_LAYER = 'iris'
export const IRIS_FILL_LAYER_ID = 'iris-fill'
export const IRIS_LINE_LAYER_ID = 'iris-line'
export const IRIS_MIN_ZOOM = 9
export const IRIS_MAX_ZOOM = 13

// --- DPE couleurs (charte officielle) ---

export const DPE_COLORS = {
  A: '#009B4E',
  B: '#53B84B',
  C: '#C8D841',
  D: '#FFED00',
  E: '#F4A534',
  F: '#E8501A',
  G: '#D70029',
}

export const DPE_COLOR_MISSING = '#cccccc'

export const DPE_LABELS = {
  A: 'Excellent',
  B: 'Très bon',
  C: 'Bon',
  D: 'Moyen',
  E: 'Insuffisant',
  F: 'Mauvais',
  G: 'Très mauvais',
}

export const DPE_CLASSES = ['A', 'B', 'C', 'D', 'E', 'F', 'G']

/**
 * Expression MapLibre GL pour la couleur de remplissage par classe DPE.
 */
export function buildDPEColorExpression() {
  return [
    'match',
    ['coalesce', ['get', 'classe_bilan_dpe'], ''],
    'A', DPE_COLORS.A,
    'B', DPE_COLORS.B,
    'C', DPE_COLORS.C,
    'D', DPE_COLORS.D,
    'E', DPE_COLORS.E,
    'F', DPE_COLORS.F,
    'G', DPE_COLORS.G,
    DPE_COLOR_MISSING,
  ]
}
